import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { call, cancel, select, takeEvery } from 'redux-saga/effects';
import { IAppState } from '@ps20-frontend/apps/checkout-store';
import {
  App,
  areFENummerEqual,
  FEVorvertragsnummer,
  normalizeApp,
  VnWechselAngabenElement,
} from '@ps20-frontend/frontend-models';
import cloneDeep from 'lodash/cloneDeep';
import { safeSaga } from '@ps20-frontend/safe-saga';

export function* watchVnWechselDataRequested() {
  yield takeEvery(
    GlobalActions.VN_WECHSEL_DATA_REQUESTED,
    safeSaga(provideVnWechselData, App.SHOP_CHECKOUT),
  );
}

export function* provideVnWechselData(action: GlobalAction<FEVorvertragsnummer[]>) {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const clonedState = cloneDeep(state);
  const stateAngabenListe: VnWechselAngabenElement[] = clonedState.vnWechselAngaben.angabenListe;

  const emptyVnWechselDataAction = new GlobalActions().provideVnWechselData({
    vnWechselGrundAngabenVorhanden: false,
    angabenListe: [],
    vnWechselgrundList: [],
  });

  if (stateAngabenListe.length < 1) {
    yield call(globalPut.put, emptyVnWechselDataAction);
    yield cancel();
  }

  const gesuchteFeNummern: FEVorvertragsnummer[] = action.payload;

  let foundAngabenElemente: VnWechselAngabenElement[] = stateAngabenListe.filter(angabe => {
    const angabeFeNummern: FEVorvertragsnummer[] = angabe?.fremdVNVorvertraege.reduce(
      (acc, angabe) => acc.concat(angabe.vorvertragsnummer),
      [],
    );
    return angabeFeNummern.some(angabeNummer =>
      gesuchteFeNummern.some(gesuchteNummer => areFENummerEqual(angabeNummer, gesuchteNummer)),
    );
  });

  if (foundAngabenElemente && foundAngabenElemente.length > 0) {
    foundAngabenElemente = foundAngabenElemente.map(element => {
      element.fremdVNVorvertraege = element.fremdVNVorvertraege.filter(vorvertrag =>
        gesuchteFeNummern.some(gesuchteNummer =>
          areFENummerEqual(gesuchteNummer, vorvertrag.vorvertragsnummer),
        ),
      );
      if (element.fremdVNVorvertraege && element.fremdVNVorvertraege.length > 0) {
        element.fremdVNVorvertraege = element.fremdVNVorvertraege.map(vorvertrag => {
          const sourceApp =
            vorvertrag.vorvertragsnummer?.produktIds?.[0];
          const normalizedApp = normalizeApp(sourceApp, {
            sourceAppType: sourceApp,
            beibehalten: false,
            featureToggles: clonedState.transientState?.featureToggles as {
              [key: string]: boolean;
            },
          });
          return {
            ...vorvertrag,
            vorvertragsnummer: {
              ...vorvertrag.vorvertragsnummer,
              produktIds: [normalizedApp],
            },
            vnWechselGrund: [{ appId: normalizedApp }],
          };
        });
      }
      return element;
    });

    yield call(
      globalPut.put,
      new GlobalActions().provideVnWechselData({
        vnWechselgrundList: clonedState.vnWechselAngaben.vnWechselgrundList,
        angabenListe: foundAngabenElemente,
        vnWechselGrundAngabenVorhanden: true,
      }),
    );
  } else {
    yield call(globalPut.put, emptyVnWechselDataAction);
    yield cancel();
  }
}
